export const hastaData = [
  {
    id: 1,
    text: "Yavuz Selim",
    day: "Dec 12th at 2:30pm",
    isDone: false,
    myDoctor: "DR Ayse Okur",
  },
  {
    id: 2,
    text: "Mihrimah Sultan",
    day: "Dec 13th at 1:30pm",
    isDone: true,
    myDoctor: "DR Fatma Adil",
  },
  {
    id: 3,
    text: "Fatih Mehmet",
    day: "Dec 14th at 3:00pm",
    isDone: false,
    myDoctor: "DR Oya Başar",
  },
  {
    id: 4,
    text: "İpek Bilir",
    day: "Dec 12th at 2:30pm",
    isDone: false,
    myDoctor: "DR Ahmet Bilen",
  },
  {
    id: 5,
    text: "Haluk Yilmaz",
    day: "Dec 13th at 1:30pm",
    isDone: true,
    myDoctor: "DR Ahmet Bilen",
  },
  {
    id: 6,
    text: "Ayşe Güler",
    day: "Dec 14th at 3:00pm",
    isDone: false,
    myDoctor: "DR Oya Başar",
  },
];

export const doctorData = [
  {
    id: 0,
    doctorName: "DR Ahmet Bilen",
    doctorImg: "https://www.shutterstock.com/image-photo/portrait-man-confident-doctor-hospital-600nw-2469643607.jpg",
  },
  {
    id: 1,
    doctorName: "DR Ayse Okur",
    doctorImg: "https://media.istockphoto.com/id/1212968981/de/foto/medizinisches-konzept-der-jungen-%C3%A4rztin-im-wei%C3%9Fen-mantel-mit-stethoskop.jpg?s=612x612&w=is&k=20&c=yRruamBsWUi8M1WSt1FmHXCKKvvUb7YZPxY0BbErPsQ=",
  },
  {
    id: 2,
    doctorName: "DR Fatma Adil",
    doctorImg:
      "https://media.istockphoto.com/id/1487135554/de/foto/gesundheitswesen-berater-und-portr%C3%A4t-eines-arztes-im-b%C3%BCro-f%C3%BCr-medizinische-arbeit-kardiologie.jpg?s=612x612&w=is&k=20&c=8NKV18x0Rn3ksWz0EGAa4GLd02Oio9HTNxgXnxG2lCw=",
  },
  {
    id: 3,
    doctorName: "DR Oya Başar",
    doctorImg:
      "https://media.istockphoto.com/id/1425798958/de/foto/foto-einer-selbstbewussten-%C3%A4rztin-im-krankenhaus-die-l%C3%A4chelnd-in-die-kamera-schaut.jpg?s=612x612&w=is&k=20&c=mAWI3WhcoLPbbJyn6-hdqn4staFupffGFvl-tOER1X4=",
  },
];
